import { createAction } from '../utils/actions';
import { getCurrentLanguage, getCurrentLanguagePaymentUrl, getCurrentWay } from './selectors';

export const MARATHONS_LANGUAGE_FETCHING = 'MARATHONS_LANGUAGE_FETCHING';
export const MARATHONS_REVIEWS_FETCHING = 'MARATHONS_REVIEWS_FETCHING';
export const MARATHONS_SHOW_FULL_SELECTOR = 'MARATHONS_SHOW_FULL_SELECTOR';
export const MARATHONS_SHOW_REGISTRATION = 'MARATHONS_SHOW_REGISTRATION';
export const MARATHONS_WAY_UPDATED = 'MARATHONS_WAY_UPDATED';
export const MARATHONS_LANGUAGE_SELECTED = 'MARATHONS_LANGUAGE_SELECTED';
export const MARATHONS_FORM_DATA_CHANGED = 'MARATHONS_FORM_DATA_CHANGED';
export const MARATHONS_REGISTER = 'MARATHONS_REGISTER';
export const MARATHONS_RESET_ERROR = 'MARATHONS_RESET_ERROR';

export const fetchLanguages = () => (dispatch, getState, container) => dispatch(
    createAction(MARATHONS_LANGUAGE_FETCHING, container().api.marathons.getLanguages()),
);

export const fetchReviews = () => (dispatch, getState, container) => dispatch(
    createAction(MARATHONS_REVIEWS_FETCHING, container().api.marathons.getReviews()),
);

export const freeSelected = () => (dispatch, getState) => {
    dispatch(createAction(MARATHONS_WAY_UPDATED, 'FREE'));
    if (getCurrentLanguage(getState())) {
        dispatch(createAction(MARATHONS_SHOW_REGISTRATION, true));
    } else {
        dispatch(createAction(MARATHONS_SHOW_FULL_SELECTOR, true));
    }
};

export const paidSelected = () => (dispatch, getState) => {
    dispatch(createAction(MARATHONS_WAY_UPDATED, 'PAID'));
    if (getCurrentLanguage(getState())) {
        window.location = getCurrentLanguagePaymentUrl(state);
    } else {
        dispatch(createAction(MARATHONS_SHOW_FULL_SELECTOR, true));
    }
};

export const selectLanguage = languageCode => (dispatch, getState) => {
    dispatch(createAction(MARATHONS_LANGUAGE_SELECTED, languageCode));
    const state = getState();
    if (getCurrentWay(state) === 'FREE') {
        dispatch(createAction(MARATHONS_SHOW_FULL_SELECTOR, false));
        dispatch(createAction(MARATHONS_SHOW_REGISTRATION, true));
    } else {
        window.location = getCurrentLanguagePaymentUrl(state);
    }
};

export const changeFormData = (key, value) => createAction(MARATHONS_FORM_DATA_CHANGED, { key, value });

export const register = data => (dispatch, getState, container) =>
    dispatch(createAction(MARATHONS_REGISTER, container().api.marathons.register(data)));

export const resetError = key => createAction(MARATHONS_RESET_ERROR, key);



// WEBPACK FOOTER //
// ./src/marathons/actions.js